<template>
  <v-layout class="auth-wrapper" fill-height>
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col class="py-6" cols="12" sm="8" md="6" lg="5" xl="4">
          <div class="d-flex align-center justify-center mb-6">
            <v-img
              :src="require('@/assets/criptospace/logotype.png')"
              max-width="50%"
              contain
            />
          </div>

          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  name: "Auth",
};
</script>

<style lang="scss" src="./style.scss" scoped />
